export const MODAL_TYPE_EDIT_COMMENT = 'edit-comment';
